import { Box, BoxProps } from '@air/marketing-primitives';

import { SectionData } from '~/lib/contentful/custom-types';
import { SECTION_CMS_LINK_CLASS_NAME } from '~/old-marketing/components/sections/Section';
import { SectionFieldTooltip } from '~/old-marketing/components/sections/SectionFieldTooltip';
import { actionsRenderer } from '~/old-marketing/utils/actionsRenderer';
import { usePreviewMode } from '~/providers/PreviewModeProvider';

export type SectionActionsProps = Pick<BoxProps, 'css'> &
  Required<Pick<SectionData, 'actions'>> & {
    isCMSLinked?: boolean;
  };

export const SectionActions = ({ actions, css, isCMSLinked }: SectionActionsProps) => {
  const { isPreview } = usePreviewMode();

  const element = (
    <Box className={isPreview ? SECTION_CMS_LINK_CLASS_NAME : ''} css={css}>
      {actionsRenderer(actions)}
    </Box>
  );

  return isCMSLinked ? <SectionFieldTooltip field="Actions">{element}</SectionFieldTooltip> : element;
};
